class Variation {
  constructor() {
    this.index = undefined;
    this.visit = 0;
    this.winRate = 0;
  }
}

export default Variation;